import React from 'react'
import styles from './itemCard.module.css'
import { Col } from 'react-bootstrap'

export interface ItemCardProps {
  thumbImageUrl: string
  title: string
  subtitle?: string
  withGift?: boolean
  onClick: () => void
}

const ItemCard: React.FC<ItemCardProps> = ({
  thumbImageUrl,
  title,
  subtitle,
  withGift,
  onClick
}) => {
  return (
    <Col
      xs={6}
      md={4}
      className={styles.categoryItem}
      data-testid="itemCard"
      onClick={onClick}
    >
      {withGift && (
        <div className={styles.outer}>
          <div className={styles.inner}>
            <img
              src="/icons/gift-ribbon.png"
              alt="gift-icon"
              className={styles.giftIcon}
            />
          </div>
        </div>
      )}
      <img
        className={styles.thumbImage}
        src={thumbImageUrl}
        alt={`${title} thumbnail`}
      />
      {subtitle ? (
        <p className={styles.caption}>
          <span>{title}</span>
          <br />
          <span className="gray-text">{subtitle}</span>
        </p>
      ) : (
        <p className={styles.caption}>{title}</p>
      )}
    </Col>
  )
}

export default ItemCard
